import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

export default function UseClientTripsNegotiations() {
  const { authFetch } = useAuth();

  const [tripsNegotiations, setTripsNegotiations] = useState([]);
  const [loadingTripsNegotiations, setLoadingTripsNegotiations] =
    useState(false);

  const [errorTripsNegotiations, setErrorTripsNegotiations] = useState("");

  const fetchTripsNegotiations = useCallback(async () => {
    //if (!accessToken) return;

    try {
      setLoadingTripsNegotiations(true);
      setErrorTripsNegotiations("");

      const response = await authFetch(
        `${API_URL}/api/client-trip-negotiations/`,
        {
          method: "GET",
          headers: {
            //Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.detail || "Erro ao buscar negociações.");
      }

      setTripsNegotiations(data.resultados || []);
    } catch (err) {
      setErrorTripsNegotiations(err.message || "Erro inesperado.");
    } finally {
      setLoadingTripsNegotiations(false);
    }
  }, [authFetch]);

  useEffect(() => {
    fetchTripsNegotiations();
  }, [fetchTripsNegotiations]);

  return {
    tripsNegotiations,
    loadingTripsNegotiations,
    errorTripsNegotiations,
    refetchTripsNegotiations: fetchTripsNegotiations,
  };
}
